module.exports = __webpack_public_path__ + "img/386192725.d6b94fa2.png";